import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })
export class RecaptchaService {

  execute(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(environment.recaptcha.siteKey, { action })
          .then((token: string) => {
            resolve(token);
          })
          .catch((err: any) => {
            reject(err);
          });
      });
    });
  }

}
